export default "__VITE_ASSET__BLgBMqWR__"